import { render } from "./FriendlyGames.vue?vue&type=template&id=41b846db"
import script from "./FriendlyGames.vue?vue&type=script&lang=js"
export * from "./FriendlyGames.vue?vue&type=script&lang=js"

import "./FriendlyGames.vue?vue&type=style&index=0&id=41b846db&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__